export const EXPRESSION_EQUAL = 'eq';
export const EXPRESSION_NOT_EQUAL = 'neq';
export const EXPRESSION_CONTAINS = 'ct';
export const EXPRESSION_NOT_CONTAINS = 'nct';
export const EXPRESSION_GT = 'gt';
export const EXPRESSION_GTE = 'gte';
export const EXPRESSION_LT = 'lt';
export const EXPRESSION_LTE = 'lte';
export const EXPRESSION_TRUE = 'true';
export const EXPRESSION_FALSE = 'false';
export const EXPRESSION_BETWEEN = 'between';
export const EXPRESSION_IN = 'in';
export const FILTER_EXPRESSIONS = {
    [EXPRESSION_EQUAL]: 'Equals',
    [EXPRESSION_NOT_EQUAL]: 'Not Equals',
    [EXPRESSION_CONTAINS]: 'Contains',
    [EXPRESSION_NOT_CONTAINS]: 'Doesn\'t Contain',
    [EXPRESSION_GT]: 'Greater than',
    [EXPRESSION_GTE]: 'Greater or eq. than',
    [EXPRESSION_LT]: 'Less than',
    [EXPRESSION_LTE]: 'Less or eq. than',
    [EXPRESSION_TRUE]: 'TRUE',
    [EXPRESSION_FALSE]: 'FALSE',
    [EXPRESSION_BETWEEN]: 'Between',
    [EXPRESSION_IN]: 'In'
};
